import React from 'react';

export default function IpedsCodeModalContent() {
  return (
    <p>
      Unique identification number assigned to postsecondary institutions
      surveyed through the Integrated Postsecondary Education Data System
      (IPEDS). Also referred to as UNITID or IPEDS ID.
    </p>
  );
}
